import {
    PHONE_CALL_TRANSCRIPT_WEBSOCKET_ACTIONS,
    TranscriptEventType,
} from '../../../../resources/phoning/types';

import type { TranscriptNotificationState, TranscriptEventAttributes } from './types';

type TranscriptEventResult = {
    process: 'started' | 'failed' | 'completed' | 'ignored';
    eventType: TranscriptEventType | null;
    isSummaryOnly: boolean;
};

export const mapTranscriptEvent = (
    prevState: TranscriptNotificationState,
    attrs: TranscriptEventAttributes,
): TranscriptEventResult => {
    const { action, phoneCallId } = attrs;

    switch (action) {
        case PHONE_CALL_TRANSCRIPT_WEBSOCKET_ACTIONS.RECORDING_ASSIGNED:
        case PHONE_CALL_TRANSCRIPT_WEBSOCKET_ACTIONS.TRANSCRIPT_REGENERATION_REQUESTED:
            return {
                process: 'started',
                eventType: 'call-transcription-started',
                isSummaryOnly: false,
            };

        case PHONE_CALL_TRANSCRIPT_WEBSOCKET_ACTIONS.SUMMARY_REGENERATION_REQUESTED:
            return {
                process: 'started',
                eventType: 'call-summary-started',
                isSummaryOnly: true,
            };

        case PHONE_CALL_TRANSCRIPT_WEBSOCKET_ACTIONS.TRANSCRIPTION_FAILED:
        case PHONE_CALL_TRANSCRIPT_WEBSOCKET_ACTIONS.SUMMARIZATION_FAILED:
            return {
                process: 'failed',
                eventType: 'call-transcription-failed',
                isSummaryOnly: false,
            };

        case PHONE_CALL_TRANSCRIPT_WEBSOCKET_ACTIONS.SUMMARIZATION_COMPLETED: {
            const initiatingAction =
                prevState.phoneCallId === phoneCallId ? prevState.initiatingAction : null;
            const isSummaryOnly =
                initiatingAction ===
                PHONE_CALL_TRANSCRIPT_WEBSOCKET_ACTIONS.SUMMARY_REGENERATION_REQUESTED;
            const eventType: TranscriptEventType = isSummaryOnly
                ? 'call-summary-ended'
                : 'call-transcription-ended';

            return {
                process: 'completed',
                eventType,
                isSummaryOnly,
            };
        }

        default:
            return {
                process: 'ignored',
                eventType: null,
                isSummaryOnly: false,
            };
    }
};
